import{createContext}from"react";export var DiscordGiveawayCampaignContext=/*#__PURE__*/createContext({isOpen:false,toggle:function toggle(){}});